import React, { useContext, useState } from 'react';
import { FaStar } from 'react-icons/fa';
import './AddReview.css';
import { UrlContext } from '../../Context/UrlContext';

function AddReview({ productId, onReviewSubmitted, isOpen, onClose }) {

      const { apiBaseUrl } = useContext(UrlContext);

    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [reviewText, setReviewText] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const storedUser = localStorage.getItem('user');
    const user = storedUser && storedUser !== 'undefined' && storedUser !== 'null' ? JSON.parse(storedUser) : null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsSubmitting(true);

        try {
            // Validate user
            if (!user || !user.id) {
                throw new Error('Please log in to submit a review');
            }

            // Validate product ID
            if (!productId) {
                throw new Error('Product ID is missing');
            }

            // Validate rating
            if (!rating) {
                throw new Error('Please select a rating');
            }

            // Validate review text
            if (!reviewText.trim()) {
                throw new Error('Please write a review');
            }

            const reviewData = {
                user_id: parseInt(user.id),
                product_id: parseInt(productId),
                rating: parseInt(rating),
                review_text: reviewText.trim()
            };

            console.log('Submitting review data:', reviewData);

            const response = await fetch(`${apiBaseUrl}/reviews`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(reviewData)
            });

            const data = await response.json();
            console.log('Server response:', data);

            if (!response.ok) {
                throw new Error(data.message || 'Failed to submit review');
            }

            // Reset form
            setRating(0);
            setReviewText('');
            setError('');
            
            // Close modal and notify parent
            if (onReviewSubmitted) {
                onReviewSubmitted();
            }
            onClose();
        } catch (err) {
            console.error('Error submitting review:', err);
            setError(err.message || 'Failed to submit review. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="review-form-container" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Write Your Review</h3>
                    <button className="close-button" onClick={onClose}>&times;</button>
                </div>
                
                <form onSubmit={handleSubmit}>
                    <div className="rating-section">
                        <label>Rating:</label>
                        <div className="stars">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <FaStar
                                    key={star}
                                    size={32}
                                    className="star"
                                    color={star <= (hover || rating) ? "#ffc107" : "#e4e5e9"}
                                    onMouseEnter={() => setHover(star)}
                                    onMouseLeave={() => setHover(0)}
                                    onClick={() => setRating(star)}
                                />
                            ))}
                        </div>
                    </div>

                    <div className="review-section">
                        <label htmlFor="review">Your Review:</label>
                        <textarea
                            id="review"
                            value={reviewText}
                            onChange={(e) => setReviewText(e.target.value)}
                            placeholder="Share your experience with this product..."
                            rows="5"
                            maxLength="500"
                            required
                        />
                    </div>

                    {error && <div className="error-message">{error}</div>}

                    <button 
                        type="submit" 
                        className="submit-btn"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Submitting...' : 'Submit Review'}
                    </button>

                    {/* Debug info */}
                    <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                        Product ID: {productId}<br />
                        User ID: {user?.id}
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddReview;
